import { ApiResponseType } from './api';
import { axiosInstance } from './index';
import {photoaxiosInstance} from './index';


export const eventService = {
   
    
   
   
    async eventRegistration( data: any) {
        const { data: responseData } = await axiosInstance.post(`event/registration`,data);
        return responseData as ApiResponseType;
    },

    async editEvent( data: any) {
        const { data: responseData } = await axiosInstance.post(`event/editEvent`,data);
        return responseData as ApiResponseType;
    },
    async getEventFeeDetails(data: any) {
        const { data: responseData } = await axiosInstance.post(`event/getEventFeeDetails`, data);
        return responseData;
    },

    async updateEventPaymentDetails(data: any) {
        const { data: responseData } = await axiosInstance.post(`event/updateEventPayment`, data);
        return responseData;
    },
    async getEventDetailsforVerification(status:any){
        const { data: responseData } = await axiosInstance.get(`event/getEventDetailsforVerification/${status}`);
        return responseData;
},
async updateEventApprovals(id:number,data: any) {
        const { data: responseData } = await axiosInstance.put(`event/updateEventApproval/${id}`,data);
        return responseData;
    },

async getDoctorDetailsforApproval(status:any){
        const { data: responseData } = await axiosInstance.get(`doctorReg/getDoctorDetailsForApproval/${status}`);
        return responseData;
},
async getDoctorDetailsByEventIdStatus(eventId:any,status:any){ 
    const { data: responseData } = await axiosInstance.get(`doctorReg/getDoctorDetailsByEventIdStatus/${eventId}/${status}`);
        return responseData;
},

async getDoctorDetailsByApprovalAndContactNumber(status:any, contactNumber:any){
        const { data: responseData } = await axiosInstance.get(`doctorReg/getDoctorDetailsByApprovalAndContactNumber/${status}/${contactNumber}`);
        return responseData;
},
  
async getEventsbyOrgidAndStatus(orgId:any,status:any){
        const { data: responseData } = await axiosInstance.get(`event/getEventsbyOrgid/${orgId}/${status}`);
        return responseData;
},
async getAllEventsbyOrgid(orgId:any){
        const { data: responseData } = await axiosInstance.get(`event/getAllEventsbyOrgid/${orgId}`);
        return responseData;
},
async saveDoctorPhoto(data: any){
        const { data: responseData } = await photoaxiosInstance.post(`doctorReg/upload`,data);
        return responseData;
},

async updateDoctorApprovals(data: any){
    const { data: responseData } = await axiosInstance.post(`doctorReg/docApproval`,data);
        return responseData;
},
async sendEmailcertificate(data: any){
    const { data: responseData } = await axiosInstance.post(`doctorReg/sendEmailcertificate`,data);
        return responseData;
},
async downloadCertificates(params: { ids: string; eventId: any; orgId: any }) {
    return axiosInstance.get(`doctorReg/download-certificates`, {
        params,
        responseType: "blob",
    });
},
async getFailedEmails() {
    const { data: responseData } = await axiosInstance.get(`emails/failed`);
    return responseData;
},
async deleteFailedEmails(messageIds: string[]) {
    return axiosInstance.delete(`emails/bulk`, { data: messageIds });
},

async fetchBulkStatus(uuid: string) {
    if (!uuid) return;
    const {data: responseData} = await axiosInstance.get(`bulk/status/${uuid}`);
    return responseData;
},

 async getUpComingEvents(){
    const { data: responseData } = await axiosInstance.get(`upcomingevents/futureEvents`);
         return responseData;
 },
 
 async downloadCertificate(){
     const { data: responseData } = await axiosInstance.get(`certificate/sample`);
         return responseData;
 },
 
async saveUpComingEvents(data: any){
    const { data: responseData } = await axiosInstance.post(`upcomingevents/saveEvents`,data);
        return responseData;
},

async getEventById(eventId:any){ 
    const { data: responseData } = await axiosInstance.get(`event/getEventById/${eventId}`);
        return responseData;
},

async getEventsbyId(eventId:any){
        const { data: responseData } = await axiosInstance.get(`event/getEventById/${eventId}`);
        return responseData;
},

}
